import { useState } from 'react';
import { useT } from '../i18n/translations';
import './MeetingVote.css';

const IconEdit = () => (
  <svg viewBox="0 0 24 24"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a1 1 0 0 0 0-1.41l-2.34-2.34a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/></svg>
);
const IconClose = () => (
  <svg viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
);

/**
 * EditMeetingDetailsModal — host edits the meeting's title & description
 * (goal) from inside the live room. Props: title, goal, onSave(title, goal), onClose()
 */
export default function EditMeetingDetailsModal({ title, goal, onSave, onClose }) {
  const t = useT();
  const [localTitle, setLocalTitle] = useState(title || '');
  const [localGoal,  setLocalGoal]  = useState(goal || '');
  const [error,   setError]   = useState('');
  const [saving,  setSaving]  = useState(false);

  async function handleSave() {
    if (!localTitle.trim()) { setError(t('meetings.titleField')); return; }
    setSaving(true);
    setError('');
    try {
      await onSave(localTitle.trim(), localGoal.trim());
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : t('room.detailsUpdateFailed'));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mvote-overlay" onClick={onClose}>
      <div className="mvote-modal" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="mvote-modal__header">
          <div className="mvote-modal__header-left">
            <div className="mvote-modal__header-icon"><IconEdit /></div>
            <span>{t('room.editMeetingDetailsTitle')}</span>
          </div>
          <button className="mvote-modal__close" onClick={onClose}><IconClose /></button>
        </div>

        {/* Body */}
        <div className="mvote-modal__body">
          <label className="mvote-modal__label">{t('meetings.titleField')}</label>
          <input
            className="mvote-modal__input"
            value={localTitle}
            onChange={e => { setLocalTitle(e.target.value); setError(''); }}
            autoFocus
          />

          <label className="mvote-modal__label" style={{ marginTop: 16 }}>{t('meetings.goalLabel')}</label>
          <textarea
            className="mvote-modal__input"
            style={{ minHeight: 80, resize: 'vertical', fontFamily: 'inherit' }}
            value={localGoal}
            onChange={e => setLocalGoal(e.target.value)}
          />

          {error && <p className="mvote-modal__error">{error}</p>}
        </div>

        {/* Footer */}
        <div className="mvote-modal__footer">
          <button className="mvote-modal__launch-btn" onClick={handleSave} disabled={saving}>
            <IconEdit /> {saving ? t('common.loading') : t('common.save')}
          </button>
        </div>

      </div>
    </div>
  );
}
